import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { FileDataReq } from './asset-library.model';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../../core/services/store/shared-store/shared-storage.service';
import { FileFormatService } from './fileformat.service';
import { bufferCount, map } from 'rxjs/operators';
import { SharedServiceToken } from '../../../core/services/store/token-store/shared-storage.service-token';
import find from 'lodash/find';
import values from 'lodash/values';

@Injectable({
  providedIn: 'root',
})
export class AssetsService {
  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private fileFormatService: FileFormatService,
    private sharedServiceToken: SharedServiceToken
  ) {}

  private assetsListCash: any = [];

  private createEntityUri(preSignedURL?: boolean): string {
    const baseUrl = `${environment.controlBaseUrl}${
      environment.flowManagerBaseUri
    }/v2/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`;
    const preSignUrl = `${environment.controlBaseUrl}/emulator${
      environment.flowManagerBaseUri
    }/v2/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`;
    return preSignedURL ? preSignUrl : baseUrl;
  }

  /* getAssetsAPI(isStream?: boolean, trigger?: Observable<any>) {
    const bufferedResponse = this.eventSourceToObservable(`${this.createEntityUri()}/files?stream=true`)
           .pipe(
               bufferCount(20)
           );
       return isStream ? zip(bufferedResponse, trigger).pipe(
               map(data => {
                   return data[0];
               })
           ) :*/
  getAssetsAPI() {
    return this.http.get(`${this.createEntityUri()}/files`);
  }

  getAssetDataById(reference, callback) {
    // TODO: GET ASSET DATA BY REFERENCE ID ENDPOINT
    if (!this.assetsListCash || this.assetsListCash.length === 0) {
      this.getAssetsAPI().subscribe((data) => {
        this.assetsListCash = data;
        callback(find(this.assetsListCash, { reference }));
      });
    }
    callback(find(this.assetsListCash, { reference }));
  }

  setFileData(file, encrypted, resolution?, preSignedURL?) {
    const body: FileDataReq = {
      fileName: file.name,
      contentType: file.type !== '' ? file.type.toLowerCase() : this.getFileType(file),
      fileHash: encrypted.toString(),
    };

    if (resolution) {
      body.resolution = resolution;
    }

    if (preSignedURL) {
      return this.http.post(`${this.createEntityUri(preSignedURL)}/emulator/upload`, body);
    }

    return this.http.post(`${this.createEntityUri()}/upload`, body);
  }

  getFileType(file) {
    const lastDot = file.name.lastIndexOf('.');
    const ext = file.name.substring(lastDot + 1);
    return this.fileFormatService.getMime(ext).toLowerCase();
  }

  uploadFile(file, data): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({
      ...data.customMetadata,
      'Content-Type': file.type !== '' ? file.type.toLowerCase() : this.getFileType(file),
    });

    const req = new HttpRequest('PUT', data.uploadURL, file, {
      headers: headers,
      reportProgress: true,
    });
    return this.http.request(req);
  }

  renameFile(body) {
    return this.http.post(`${this.createEntityUri()}/rename`, body);
  }

  deleteAsset(reference) {
    const body = { reference };
    return this.http.post(`${this.createEntityUri()}/delete`, body);
  }

  /*eventSourceToObservable(url: string): Observable<any> {
        const accessToken = this.sharedServiceToken.getItem('access_token');
        const eventSource = new EventSource(url + '&access_token=' + accessToken.replaceAll('"', ''));
        return new Observable(observer => {
            eventSource.onmessage = e => {
                observer.next(JSON.parse(e.data));
            };
            eventSource.onerror = e => {
                eventSource.close();
                observer.complete();
            };
        });
    }*/
}
